import * as vibrancyActions from './vibrancy/actions'
import * as AIMetricAction from './AIMetricOT/actions'

const allActions = {
  ...vibrancyActions,
  ...AIMetricAction,
}

export default allActions
